export default class APIHelper {
    static get({ url, urlParams, responseType }) {
        return this.send({
            url,
            urlParams,
            responseType,
            method: 'GET',
            okResult: 200,
        });
    }

    static post({ url, urlParams, responseType, data }) {
        return this.send({
            url,
            urlParams,
            responseType,
            data,
            method: 'POST',
            okResult: 200,
        });
    }

    static send({ method, url, urlParams, responseType, data, okResult }) {
        if (urlParams) {
            const query = this.toQueryString(urlParams);

            if (query) {
                url = url + '?' + query;
            }
        }

        return this.callApi({
            url,
            method,
            responseType,
            data,
            okResult
        });
    }

    static callApi({ method, url, responseType, okResult, data }) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            xhr.onload = () => {
                // tslint:disable-next-line:triple-equals
                if (xhr.status == okResult) {
                    if (xhr.responseText) {
                        resolve(JSON.parse(xhr.responseText));
                    } else {
                        resolve(xhr.response);
                    }
                } else {
                    this.callReject(xhr, reject);
                }
            };

            xhr.onerror = () => {
                this.callReject(xhr, reject);
            };

            xhr.onabort = () => {
                this.callReject(xhr, reject);
            };

            xhr.open(method, url, true);

            if (responseType) {
                xhr.responseType = responseType;
            }

            if (data) {
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.send(JSON.stringify(data));
            } else {
                xhr.send();
            }
        });
    }
    
    static tryGetResponse(xhr) {
        var response;

        try {
            response = JSON.parse(xhr.response);
        } catch (e) {
            response = undefined;
        }

        return response;
    }

    static callReject(xhr, reject, isConnectionError = false) {
        if (reject) {
            reject({
                status: xhr.status,
                response: this.tryGetResponse(xhr),
                isConnectionError
            });
        }
    }

    static toQueryString(obj) {
        if (typeof obj !== 'object') {
            return '';
        }

        return Object.keys(obj)
            .map((o) => this.getQueryStringParameter(o, obj[o]))
            .filter((o) => !!o)
            .join('&');
    }

    static getQueryStringParameter(key, value) {
        if (value === null || typeof value === 'undefined') {
            return '';
        }

        const items = [];

        if (Array.isArray(value)) {
            value.forEach((val) => {
                items.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
            });
        } else {
            items.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }

        return items.join('&');
    }
}
